// extracted by mini-css-extract-plugin
export var statItem = "_l0-1";
export var statsRow = "_l0-0";